import checkdigit from 'checkdigit';
import IBAN from 'iban';
import React, { useState, useCallback } from 'react';

import { IconTypes } from '@eika/icon';
import { Input } from '@eika/input';
import { SuccessLabel } from '@eika/label';

import { Config } from '../config';

const ValidateIBAN: React.FC<Config> = ({ texts }) => {
    const [state, setState] = useState<{ value: string; error: string; valid: boolean }>({
        value: '',
        error: '',
        valid: false,
    });

    const validateIBAN = useCallback((iban: string): boolean => {
        const isValidIban = IBAN.isValid(iban);
        const validCheckSum = checkdigit.mod11.isValid(iban.slice(4, 15));
        return isValidIban && validCheckSum;
    }, []);

    const verify = useCallback(
        (event: React.ChangeEvent<HTMLInputElement>): void => {
            const userInput = event.target.value;
            setState((prevState) => ({ ...prevState, value: userInput }));

            if (userInput) {
                if (validateIBAN(userInput)) {
                    setState((prevState) => ({ ...prevState, error: '', valid: true }));
                } else {
                    setState((prevState) => ({
                        ...prevState,
                        error: texts.errorNotValid,
                        valid: false,
                    }));
                }
            } else {
                setState((prevState) => ({ ...prevState, error: '', valid: false }));
            }
        },
        [validateIBAN, texts],
    );

    return (
        <div className="esc-ibangenerator__input">
            <Input value={state.value} onChange={verify} error={state.error} label={texts.inputLabelIban} />
            {state.valid && <SuccessLabel text={texts.successMessageValid} icon={IconTypes.USP_CHECKMARK_24} />}
        </div>
    );
};

export default ValidateIBAN;
